import { ErrorBanner } from "components/Error/ErrorBanner";
import NewTextFormComponent from "components/Forms/NewTextFormComponent";
import BlockSpinner from "components/Spinners/BlockSpinner";
import { Form, Formik, type FormikHelpers } from "formik";
import type React from "react";
import * as Yup from "yup";
import { yupRequiredString } from "../../../components/Forms/yupValidators";
import { Button } from "../../../components/Theme/button";
import {
  useCreateAssetPosition,
  useCreateLocation,
} from "../../../hooks/createEntity";
import { assetTypeEnum } from "../../../kubb";

interface Props {
  company_id: string;
  scheme_id: string;
  postCreateActions?: () => any;
}

interface FormValues {
  address: "";
}

export default function AssetPositionCreateForm(
  props: Props,
): React.ReactElement {
  const createLocation = useCreateLocation(props.company_id);
  const createAssetPosition = useCreateAssetPosition(props.company_id);

  const submit = (
    values: FormValues,
    { setSubmitting, resetForm }: FormikHelpers<FormValues>,
  ): void => {
    setSubmitting(true);
    createLocation
      .update({
        scheme_id: props.scheme_id,
        company_id: props.company_id,
        address: values.address,
      })
      .then(([location]) => {
        return createAssetPosition.update({
          scheme_id: props.scheme_id,
          company_id: props.company_id,
          location_id: location.location_id,
          asset_position_type: assetTypeEnum.wireless_cluster,
        });
      })
      .then(() => {
        resetForm();
        if (props.postCreateActions) {
          props.postCreateActions();
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const initialValues: FormValues = {
    address: "",
  };
  const creating = createLocation.loading || createAssetPosition.loading;

  return (
    <Formik
      onSubmit={submit}
      initialValues={initialValues}
      validateOnMount={true}
      validationSchema={Yup.object().shape({
        address: yupRequiredString,
      })}
    >
      {({ isValid, isSubmitting }): React.ReactElement => (
        <BlockSpinner loading={creating}>
          <Form data-cy={"wireless-cluster-create"}>
            <h3 className="text-white mb-0">Add Wireless Cluster</h3>
            <NewTextFormComponent
              fieldName={"address"}
              label={{ label: "Description" }}
            />
            <Button
              type={"submit"}
              color={"brandLight"}
              disabled={isSubmitting || !isValid}
            >
              Add Wireless Cluster
            </Button>
            <ErrorBanner
              error={createLocation.error || createAssetPosition.error}
            />
          </Form>
        </BlockSpinner>
      )}
    </Formik>
  );
}
